import SchemaRules from './schema-rules'
import BasicFilters from './basic-filters'
import MathHelpers from './math'
import ScriptEditor from './script-editor'
import ScriptsBasic from './scripts-basic'
import CommentsHelpers from './comments'
import ColorsHelper from './colors'
import GoogleUpload from './google-upload'
import { convertQuotas, convertTraits } from './traits'
import { convertCustomVariables } from './variables'
import { convertValuesToTree } from '@aytm/app/stats/lib/converter'
import { SENTIMENTS } from '@aytm/app/stats/page/comments/lib/constants'
import { getTagsList } from '@aytm/app/stats/page/comments/lib/utils'
import SigtestCodec from './sigtest-codec'

// import scrollToQuestionListener from '@aytm/app/survey/editor/components/lib/scroll-to-question-rx'

if ('undefined' !== typeof window) {
  window['$STATS'] || (window['$STATS'] = {})

  window['$STATS']['SchemaRules'] = SchemaRules
  window['$STATS']['BasicFilters'] = BasicFilters
  window['$STATS']['Math'] = MathHelpers
  window['$STATS']['ScriptEditor'] = ScriptEditor
  window['$STATS']['ScriptsBasic'] = ScriptsBasic
  window['$STATS']['Comments'] = CommentsHelpers
  window['$STATS']['Colors'] = ColorsHelper
  window['$STATS']['GoogleUpload'] = GoogleUpload
  window['$STATS']['convertQuotas'] = convertQuotas
  window['$STATS']['convertTraits'] = convertTraits
  window['$STATS']['convertCustomVariables'] = convertCustomVariables
  window['$STATS']['convertValuesToTree'] = convertValuesToTree

  window['$STATS']['getTagsList'] = getTagsList

  window['$STATS']['SENTIMENTS'] = SENTIMENTS
  window['$STATS']['SigtestCodec'] = SigtestCodec
}

export {
  SchemaRules,
  BasicFilters,
  MathHelpers as Math,
  ScriptEditor,
  ScriptsBasic,
  CommentsHelpers as Comments,
  ColorsHelper as Colors,
  GoogleUpload,
  convertQuotas,
  convertTraits,
  convertCustomVariables,
  convertValuesToTree,
  getTagsList,
  SigtestCodec
  // scrollToQuestionListener as ScrollToQuestion
}
